const key = "mouldledger_device_id";

export function getDeviceId() {
  const existing = localStorage.getItem(key);
  if (existing) return existing;
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  const id = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  localStorage.setItem(key, id);
  return id;
}

export function clearDeviceForLocalTesting() {
  localStorage.removeItem(key);
}
